import{useContext as r}from"react";import{AmapContext as t}from"./Amap.js";function o(){return r(t)}export default o;
